module.exports = __webpack_public_path__ + "static/media/undraw-not-found.eb35803c.png";